<div id="card">
  <div class="card-content">
    <div class="title-block pulsate"></div>
  </div>
</div>
